import { Component, EventEmitter, inject, Input, OnInit, Output, QueryList, ViewChildren } from "@angular/core";
import { NgClass } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { ListComponent } from "../list/list.component";
import { ButtonComponent, IconComponent } from "@husbanken/designsystem-angular-core";

interface Seksjoner {
  utleiebolig: boolean;
  tilstandsvurdering: boolean;
  grunnlan: boolean;
  boligkvalitet: boolean;
  startlan: boolean;
  investeringstilskudd: boolean;
  energitilskudd: boolean;
  kompetansetilskudd: boolean;
  barnehagelan: boolean;
  bostotte: boolean;
  kommuneside: boolean;
  utleieboliglan: boolean;
  studentbolig: boolean;
}

type FilterListe = {
  [seksjon in keyof Seksjoner]?: {
    id: string;
    subId?: string;
    tittel: string;
    reduce: boolean;
    komprimertVisning?: boolean;
    default?: string[] | number[];
    multiselect?: boolean;
    qlikfield?: string;
    sorteringField?: string;
    sorteringOrientation?: string;
    qlikOptions?: object;
    type?: "checkbox" | "radio";
  }[];
};

@Component({
  selector: "stat-filter",
  templateUrl: "./filter.component.html",
  imports: [NgClass, ButtonComponent, ListComponent, IconComponent],
})
export class FilterComponent implements OnInit {
  @Input() seksjon: keyof Seksjoner;

  @Input() visFilter = false;

  @ViewChildren("qlikfilter") qlikFilters: QueryList<ListComponent>;

  @Output()
  selectedFilters = new EventEmitter<{ [key: string]: (string | number)[] }>();

  selected = {};

  objectKeys = Object.keys;

  activatedRoute = inject(ActivatedRoute);

  filterListe: FilterListe = {
    utleiebolig: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "ErTilskuddTilistandsetting", tittel: "Tilskudd til istandsetting",default: [this.activatedRoute.snapshot.queryParamMap.get("ErTilskuddTilistandsetting") ?? "Ja"], reduce: true},
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
      { id: "Hustype", tittel: "Hustype", reduce: true },
      { id: "Delmålgruppe", tittel: "Delmålgruppe", reduce: true },
    ],
    tilstandsvurdering: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
    ],
    grunnlan: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
      { id: "Boligformål", tittel: "Boligformål", reduce: true },
      { id: "Kvalitetskrav", tittel: "Kvalitetskrav", reduce: true },
      { id: "Tilvisningsavtale", tittel: "Tilvisningsavtale", reduce: true, komprimertVisning: true },
    ],
    boligkvalitet: [
      { id: "År", tittel: "År", reduce: true, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
      { id: "Beskrivelse delformål", tittel: "Formål", reduce: true },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
    ],
    bostotte: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Brukergruppe", tittel: "Brukergruppe", reduce: true },
      { id: "Eierforhold", tittel: "Eierforhold", reduce: true },
      { id: "HusstandSammensetning", tittel: "Husstand sammensetning", reduce: true },
      { id: "AntallHusstandsmedlemmer", tittel: "Antall husstandsmedlemmer", reduce: true, komprimertVisning: true },
      { id: "Aldersgruppe", tittel: "Aldersgruppe", reduce: true },
      { id: "Vedtakskode", tittel: "Avslagsårsak", reduce: true },
    ],
    startlan: [
      { id: "Låneordning", tittel: "Låneordning", default: [this.activatedRoute.snapshot.queryParamMap.get("laneordning") ?? "Ordinært startlån"], reduce: true, type: "radio" },
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
      { id: "Boforhold", tittel: "Boforhold", reduce: true },
      { id: "HusstandSammensetning", tittel: "Husstand sammensetning", reduce: true },
      { id: "Aldersgruppe", tittel: "Aldersgruppe", reduce: true },
      { id: "Samfinansiering", tittel: "Samfinansiering", reduce: true, komprimertVisning: true },
      { id: "Fullfinansiering", tittel: "Fullfinansiering", reduce: true, komprimertVisning: true },
      { id: "InnstillingÅrsak", tittel: "Avslagsårsak", reduce: true },
    ],
    investeringstilskudd: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
    ],
    energitilskudd: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Energisparing", tittel: "Type Tiltak", reduce: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
    ],
    kompetansetilskudd: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
    ],
    barnehagelan: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
    ],
    utleieboliglan: [
      { id: "År", tittel: "År", reduce: true, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
      { id: "Tilvisningsavtale", tittel: "Tilvisningsavtale", reduce: true, komprimertVisning: true },
    ],
    studentbolig: [
      { id: "År", tittel: "År", reduce: true, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
      { id: "Tiltak", tittel: "Tiltak", reduce: true },
      { id: "Søkertype", tittel: "Søkertype", reduce: true },
    ],
    kommuneside: [
      { id: "År", tittel: "År", reduce: false, komprimertVisning: true },
      { id: "Måned", tittel: "Måned", reduce: false, komprimertVisning: true },
      { id: "Fylke", subId: "Kommune", tittel: "Fylke og kommune", reduce: false, multiselect: true, qlikfield: "KommuneNr" },
    ],
  };

  ngOnInit() {
    if (!this.seksjon || !this.filterListe[this.seksjon]) {
      throw new Error("No section or invalid section specified for filter list component");
    }
    this.setCurrentYearFilter();
  }

  selection(items: { [key: string]: (string | number)[] }) {
    Object.keys(items).forEach(id => {
      if (items[id].length > 0) {
        this.selected[id] = items[id];
      } else {
        delete this.selected[id];
      }
    });
    this.selectedFilters.emit(this.selected);
  }

  removeFilter() {
    this.selected = {};
    this.qlikFilters.forEach(filter => filter.reset());
  }

  setCurrentYearFilter() {
    const currentTime = new Date();
    currentTime.setDate(currentTime.getDate() - 31);
    const year = currentTime.getFullYear();

    this.filterListe[this.seksjon].forEach((filter, key) => {
      if (filter.id === "År") {
        this.filterListe[this.seksjon][key].default = [year];
      }
    });
  }
}
